/*
 * MyDogGrip – règles d'achat communes à la fiche produit et à la barre d'achat fixe.
 * 1. Écusson : choix prénom / logo / vierge, validation du prénom sans troncature silencieuse.
 * 2. Taille : un nouveau visiteur doit choisir une taille ; sinon le bouton guide vers les tailles.
 * Les deux règles passent par la validation native du formulaire produit : toute soumission
 * (bouton principal, barre fixe) est bloquée tant qu'un champ requis n'est pas valide.
 */
(function () {
  'use strict';

  var config = window.MDG_ACHAT || {};
  // Textes traduits fournis par layout/theme.liquid (clés « mdg » des fichiers de langue), français par défaut.
  var T = Object.assign({
    nameEmpty: 'Indiquez le prénom de votre chien, ou choisissez un autre type d’écusson.',
    nameLong: 'Ce prénom compte [n] caractères : la broderie en accepte [max] au maximum, espaces compris. Raccourcissez-le pour continuer.',
    nameChar: 'Le caractère « [char] » ne peut pas être brodé. Utilisez des lettres, des espaces, des tirets ou des apostrophes.',
    nameLetter: 'Le prénom doit commencer par une lettre.',
    colon: ' : ',
    toChoose: 'à choisir',
    stickyToChoose: 'taille à choisir',
    expressHint: 'Choisissez la taille et l’écusson pour activer le paiement express.'
  }, config.t || {});
  var NAME_RE = /^[\p{L}][\p{L}\p{M} '’-]*$/u;
  var FORBIDDEN_RE = /[^\p{L}\p{M} '’-]/u;

  function store(key, value) {
    try {
      if (value === undefined) return JSON.parse(sessionStorage.getItem(key) || 'null');
      sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {
      return null;
    }
  }

  function countChars(text) {
    return Array.from(text).length;
  }

  function sectionOf(el) {
    return el.closest('.shopify-section') || document;
  }

  function productFormIn(section) {
    return section.querySelector('form[data-type="add-to-cart-form"]');
  }

  function reveal(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  /* ---------------- Écusson ---------------- */

  class MdgEcusson extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      this.max = parseInt(this.dataset.max, 10) || 12;
      this.key = 'mdg-ecusson-' + this.dataset.productId;
      this.input = this.querySelector('[data-mdg-name]');
      this.wrap = this.querySelector('[data-mdg-name-wrap]');
      this.count = this.querySelector('[data-mdg-count]');
      this.error = this.querySelector('[data-mdg-name-error]');
      this.preview = this.querySelector('[data-mdg-preview]');
      this.showError = false;

      var saved = store(this.key);
      if (saved) {
        var radio = this.querySelector('[data-mdg-choice="' + saved.choice + '"]');
        if (radio) radio.checked = true;
        if (typeof saved.name === 'string') this.input.value = saved.name;
      }

      this.addEventListener('change', this.update.bind(this));
      this.input.addEventListener('input', this.update.bind(this));
      this.input.addEventListener('blur', this.onBlur.bind(this));
      this.input.addEventListener('invalid', this.onInvalid.bind(this));
      this.update();
    }

    choice() {
      var checked = this.querySelector('[data-mdg-choice]:checked');
      return checked ? checked.getAttribute('data-mdg-choice') : 'prenom';
    }

    onBlur() {
      var tidy = this.input.value.replace(/\s+/g, ' ').trim();
      if (tidy !== this.input.value) this.input.value = tidy;
      if (tidy !== '') this.showError = true;
      this.update();
    }

    onInvalid(event) {
      event.preventDefault();
      this.showError = true;
      this.update();
      reveal(this);
      this.input.focus({ preventScroll: true });
    }

    message(value) {
      var text = value.trim();
      if (text === '') {
        return T.nameEmpty;
      }
      var n = countChars(text);
      if (n > this.max) {
        return T.nameLong.replace('[n]', n).replace('[max]', this.max);
      }
      var bad = text.match(FORBIDDEN_RE);
      if (bad) {
        return T.nameChar.replace('[char]', bad[0]);
      }
      if (!NAME_RE.test(text)) {
        return T.nameLetter;
      }
      return '';
    }

    update() {
      var choice = this.choice();
      var isName = choice === 'prenom';
      var value = this.input.value;
      this.wrap.hidden = !isName;
      this.input.disabled = !isName;
      this.input.required = isName;

      var n = countChars(value.trim());
      this.count.textContent = n + '/' + this.max;
      this.count.dataset.over = n > this.max ? 'true' : 'false';

      var msg = isName ? this.message(value) : '';
      this.input.setCustomValidity(msg);
      var visible = msg !== '' && this.showError;
      this.input.setAttribute('aria-invalid', visible ? 'true' : 'false');
      this.error.hidden = !visible;
      this.error.textContent = visible ? msg : '';

      if (this.preview) {
        this.preview.dataset.state = choice;
        if (choice === 'logo') this.preview.textContent = this.preview.dataset.logo || 'MyDogGrip';
        else if (choice === 'vierge') this.preview.textContent = ' ';
        else this.preview.textContent = value.trim() || this.preview.dataset.sample || 'Chloé';
      }

      store(this.key, { choice: choice, name: value });
      this.dispatchEvent(new CustomEvent('mdg:validity', { bubbles: true }));
    }

    isValid() {
      return this.choice() !== 'prenom' || this.message(this.input.value) === '';
    }
  }

  if (!customElements.get('mdg-ecusson')) customElements.define('mdg-ecusson', MdgEcusson);

  /* ---------------- Taille ---------------- */

  function sizeKey(picker) {
    return 'mdg-taille-' + picker.dataset.productId;
  }

  function checkedSize(picker) {
    var r = picker.querySelector('.mdg-option--taille input[type="radio"]:checked');
    return r ? r.value : null;
  }

  // La taille compte comme choisie seulement si c'est celle que le visiteur a cliquée.
  function sizeChosen(picker) {
    var saved = store(sizeKey(picker));
    return typeof saved === 'string' && saved === checkedSize(picker);
  }

  function applySizeGate(picker) {
    var fieldset = picker.querySelector('.mdg-option--taille');
    if (!fieldset) return;
    var section = sectionOf(picker);
    var form = productFormIn(section);
    if (!form) return;
    var chosen = sizeChosen(picker);

    var gate = fieldset.querySelector('.mdg-gate');
    if (!gate) {
      gate = document.createElement('input');
      gate.className = 'mdg-gate';
      gate.type = 'text';
      gate.tabIndex = -1;
      gate.setAttribute('aria-hidden', 'true');
      gate.required = true;
      gate.addEventListener('invalid', function (event) {
        event.preventDefault();
        var err = section.querySelector('[data-mdg-size-error]');
        if (err) err.hidden = false;
        reveal(fieldset);
        var first = fieldset.querySelector('input[type="radio"]:not([aria-disabled="true"])');
        if (first) first.focus({ preventScroll: true });
      });
      fieldset.appendChild(gate);
    }
    gate.setAttribute('form', form.getAttribute('id'));
    gate.value = chosen ? '1' : '';

    fieldset.classList.toggle('mdg-unchosen', !chosen);
    var err = section.querySelector('[data-mdg-size-error]');
    if (err) {
      if (chosen) err.hidden = true;
      err.setAttribute('id', err.id || 'mdg-size-error');
      fieldset.setAttribute('aria-describedby', err.id);
    }

    var label = fieldset.querySelector('[data-mdg-option-value="taille"]');
    var wanted = T.colon + (chosen ? String(checkedSize(picker) || '').split(' (')[0] : T.toChoose);
    if (label && label.textContent !== wanted) label.textContent = wanted;

    var sticky = document.querySelector('sticky-add-to-cart[data-product-id="' + picker.dataset.productId + '"] .sticky-add-to-cart__variant');
    if (sticky && !chosen) {
      var color = picker.querySelector('.mdg-option--couleur input:checked');
      var stickyText = (color ? color.value + ' · ' : '') + T.stickyToChoose;
      if (sticky.textContent !== stickyText) sticky.textContent = stickyText;
    }
    syncExpress(section);
  }

  function syncExpress(section) {
    var form = productFormIn(section);
    if (!form) return;
    var express = section.querySelector('.accelerated-checkout-block');
    if (!express) return;
    var fieldsOk = Array.prototype.every.call(form.elements, function (el) {
      return !el.willValidate || el.validity.valid;
    });
    express.classList.toggle('mdg-locked', !fieldsOk);
    express.setAttribute('aria-disabled', fieldsOk ? 'false' : 'true');
    var hint = section.querySelector('[data-mdg-express-hint]');
    if (!hint) {
      hint = document.createElement('p');
      hint.className = 'mdg-express-hint';
      hint.setAttribute('data-mdg-express-hint', '');
      hint.textContent = T.expressHint;
      express.parentNode.insertBefore(hint, express);
    }
    hint.hidden = fieldsOk;
  }

  function initPickers() {
    if (config.requireSize === false) return;
    document.querySelectorAll('variant-picker[data-template-product-match="true"]').forEach(applySizeGate);
  }

  document.addEventListener(
    'click',
    function (event) {
      var radio = event.target.closest && event.target.closest('.mdg-option--taille input[type="radio"]');
      if (!radio) return;
      var picker = radio.closest('variant-picker');
      if (!picker) return;
      store(sizeKey(picker), radio.value);
      applySizeGate(picker);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    var radio = event.target.closest && event.target.closest('.mdg-option--taille input[type="radio"]');
    if (!radio || (event.key !== ' ' && event.key !== 'Enter')) return;
    var picker = radio.closest('variant-picker');
    store(sizeKey(picker), radio.value);
    applySizeGate(picker);
  });

  document.addEventListener('change', function (event) {
    var radio = event.target.closest && event.target.closest('.mdg-option--taille input[type="radio"]');
    if (radio) {
      var picker = radio.closest('variant-picker');
      store(sizeKey(picker), radio.value);
    }
    var section = sectionOf(event.target);
    syncExpress(section);
  });

  // Un double-clic involontaire ne doit pas ajouter deux harnais.
  var lastSubmit = new WeakMap();
  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      if (!form || form.getAttribute('data-type') !== 'add-to-cart-form') return;
      var now = Date.now();
      if (now - (lastSubmit.get(form) || 0) < 1200) {
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
      lastSubmit.set(form, now);
    },
    true
  );

  document.addEventListener('mdg:validity', function (event) {
    syncExpress(sectionOf(event.target));
  });

  // Le thème remplace le sélecteur et la barre fixe à chaque changement de variante : réappliquer.
  var pending = false;
  new MutationObserver(function () {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      initPickers();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initPickers);
  else initPickers();
})();
